import { useEffect, useRef } from 'react';
import type { SelectionState } from '../../types/economicsTypes';
import styles from './EconomicsCheckbox.module.css';

interface EconomicsCheckboxProps {
  state: SelectionState;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  ariaLabel: string;
}

// qampo-ui-library's Checkbox exposes only a boolean `check` and no indeterminate state, which
// the cascade tree's parent rows need. This local component sets `indeterminate` on the native
// input via a ref. Clicking a partial/empty box completes everything beneath; a full box clears it.
export const EconomicsCheckbox = ({ state, onChange, disabled, ariaLabel }: EconomicsCheckboxProps) => {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.indeterminate = state === 'partial';
    }
  }, [state]);

  return (
    <input
      ref={ref}
      type="checkbox"
      className={styles.checkbox}
      checked={state === 'all'}
      disabled={disabled}
      aria-label={ariaLabel}
      onChange={() => onChange(state !== 'all')}
    />
  );
};
